export default function(msg) {
  if (__DEV__) {
    console.error(msg);
  }
}
